import React from 'react';
import { ModalContext } from './use-modal';
import { isShallowEqual } from '../../../common/utils/is-shallow-equal';
import { useContextSelector } from '../../use-context-selector';
import styles from './modal-root.scss';
const ModalRoot = () => {
    const modals = useContextSelector(ModalContext, (ctx) => ctx.modals, isShallowEqual);
    const modalKeys = Object.keys(modals);
    return modalKeys.length ? (React.createElement("div", { className: styles.root }, modalKeys.map((id) => (React.createElement(React.Fragment, { key: id },
        React.createElement(React.Suspense, { fallback: null }, modals[id].modal)))))) : null;
};
export default ModalRoot;
//# sourceMappingURL=modal-root.js.map